import { useEffect, useState } from "react";
import { BsQuestionCircle } from "react-icons/bs";
import Grid, { GridColumn, GridHeader, GridRow } from "../../../../components/Grid/Grid";
import WebService, { BASE_URL } from "../../../../utility/WebService";
import WarningModal from "../../../../components/Warning/Warning";
import SucessModal from "../../../../components/SucessModal/Sucess";
import recoverIcon from '../../../../assets/images/icons8-reset-24.png';
import BackComponent from "../../../../components/BackArrow";
import HelperService from "../../../../utility/HelperService";
import { TbDownload } from "react-icons/tb";

const headers: GridHeader[] = [
    {
        title: "Client Name",
        classTitle: "text-start"
    },
    {
        title: "Agreement Type",
        classTitle: "text-start"
    },
    {
        title: "Client Ip",
        classTitle: "text-start"
    },
    {
        title: "Client Signed Date",
        classTitle: "text-start"
    },
    {
        title: "Advisor Signed Date",
        classTitle: "text-start"
    },
    {
        title: "Agreement Start Date",
        classTitle: "text-start"
    },
    {
        title: "Agreement End Date",
        classTitle: "text-start"
    },
    // {
    //     title: "Date",
    //     classTitle: "text-start"
    // },
    {
        title: "Actions",
        classTitle: "text-start"
    },
];

const ArchivedAgreement = () => {
    const [rows, setRows] = useState<GridRow[]>([]);
    const [ShowLoader, setShowLoader] = useState(false);
    const [totalCount, setTotalCount] = useState("");
    const [sucessMessage, setSucessMessage] = useState<any>()
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const [warningMessage, setWarningMessage] = useState<any>()
    const [isShowWarningModal, setShowWarningModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1)
    const user_data = JSON.parse(localStorage.getItem("user_Detail") || "{}");

    useEffect(() => {
        getList(1, "");
    }, []);

    const download = (id: any) => {
        setShowLoader(true);
        window.open(`${BASE_URL}/v2/ClientAgreements/DownloadFinalDocument?id=${id}`)
        setShowLoader(false)
    }

    const getList = (page?: any, searchText?: string) => {
        setShowLoader(true);
        WebService.getAPI({
            action: `${user_data.is_person == 'Employee' ? `/v2/ClientAgreements/GetAgreementArchiveList` : `/v2/ClientAgreements/GetClientArchiveAgreementList`}?page=${page}&keyword=${searchText}&status=COMPLETED`,
        })
            .then((res: any) => {
                setTotalCount(res.total_count);
                setShowLoader(false);
                let rows: GridRow[] = [];
                for (let i in res.list) {
                    let columns: GridColumn[] = [];
                    columns.push({ value: res.list[i].client_name ? res.list[i].client_name  : "-"});
                    columns.push({ value: res.list[i].agreement_type === 'AADHAR_E_SIGN' ? 'Aadhar E-Sign' :
                        res.list[i].agreement_type === 'E_SIGN' ? 'Wet Sign' :
                        res.list[i].agreement_type === 'SCANED_BY_BOTH' ? 'Physical' :
                        "-"});
                    columns.push({ value: res.list[i].ip_client ? res.list[i].ip_client : "-"});
                    columns.push({ value: res.list[i].client_signed_date ? HelperService.getFormatedDateAndTime(res.list[i].client_signed_date) : "-"});
                    columns.push({ value: res.list[i].advisor_signed_date ? HelperService.getFormatedDateAndTime(res.list[i].advisor_signed_date) : "-"});
                    columns.push({ value: res.list[i].start_date ? HelperService.getFormatedDateByDMY(res.list[i].start_date) : "-"});
                    columns.push({ value: res.list[i].end_date ? HelperService.getFormatedDateByDMY(res.list[i].end_date) : "-"});
                    // columns.push({ value: res.list[i].created_at ? HelperService.getFormatedDateByDMY(res.list[i].created_at) : "-"});
                    columns.push({
                        value: (
                            <a href="javascript:void(0)" className="action-btn" title="Download">
                                <TbDownload size={20} className="mr-3 text-brand" onClick={() => download(res.list[i].id)} />
                            </a>
                        )
                    });
                    
                    rows.push({ data: columns });
                }
                setRows(rows);
            })
            .catch(() => {
                setShowLoader(false);
            });
    };

    const onSorting = (page: number, searchText: string) => {
        setCurrentPage(page)
        getList(page, searchText);
    };

    const sucessCloseModal = () => {
        setShowSucessModal(false)
        setShowLoader(false);
    }
    const warningCloseModal = () => {
        setShowWarningModal(false)
        setShowLoader(false);
    }

    return (
        <>
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <div className="page-content-wraper">
                <div className="grid grid-cols-2 gap-4 mb-3">
                    <div>
                        <BackComponent
                            title={"Archived Agreement"}/>
                    </div>
                    <div className="text-right flex justify-end items-center">
                        <button type="button" className="btn bg-white px-3 py-1 rounded-md hover:shadow-xl  shadow-sm mr-3" title="Help">
                            <BsQuestionCircle size={20} className="inline mr-1" /> Help
                        </button>
                    </div>
                </div>
                <div className="table-card">
                    <Grid
                        headers={headers}
                        rows={rows}
                        ShowLoader={ShowLoader}
                        errorMessage={"No Records Found"}
                        count={totalCount}
                        onPageChange={onSorting}
                        isShowSearch={true}
                    />
                </div>
            </div>
        </>
    );
};
export default ArchivedAgreement;
